import React from "react";
import {Table} from "antd";

export const DefaultTransactionTable = ({transactions = [], subTypeLabels, Wrapper}) => {
    const table = (
        <Table
            dataSource={transactions}
            pagination={false}
            size="small"
            rowKey={(_, index) => index}
        >
            <Table.Column
                title="İşlem Tipi"
                dataIndex="subType"
                width="40%"
                render={subType => (
                    <span style={{fontWeight: 500}}>{subTypeLabels?.[subType] || subType}</span>
                )}
            />
            <Table.Column
                title="Kurye Kazancı"
                dataIndex="courierAmount"
                width="30%"
                render={courierAmount => {
                    if (courierAmount == null) return <span>-</span>;
                    const color =
                        courierAmount > 0 ? "green" : courierAmount < 0 ? "red" : undefined;
                    return <span style={{color}}>{courierAmount} TL</span>;
                }}
            />
            <Table.Column
                title="Müşteri Harcaması"
                dataIndex="clientAmount"
                width="30%"
                render={clientAmount => {
                    if (clientAmount == null) return <span>-</span>;
                    const color = clientAmount > 0 ? "green" : clientAmount < 0 ? "red" : undefined;
                    return <span style={{color}}>{clientAmount} TL</span>;
                }}
            />
        </Table>
    );

    if (!Wrapper) return table;

    return <Wrapper>{table}</Wrapper>;
};
